module.exports = __webpack_public_path__ + "img/sld_step_down_transformer_h_l1_dark.773991a4.svg";